import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInsightsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.33333 12.375V13.9583M9.5 9.20833V13.9583M12.6667 6.04167V13.9583M6.175 17.125H12.825C14.1551 17.125 14.8202 17.125 15.3282 16.8661C15.7751 16.6384 16.1384 16.2751 16.3661 15.8282C16.625 15.3202 16.625 14.6551 16.625 13.325V6.675C16.625 5.34488 16.625 4.67981 16.3661 4.17177C16.1384 3.72489 15.7751 3.36156 15.3282 3.13386C14.8202 2.875 14.1551 2.875 12.825 2.875H6.175C4.84488 2.875 4.17981 2.875 3.67177 3.13386C3.22489 3.36156 2.86156 3.72489 2.63386 4.17177C2.375 4.67981 2.375 5.34488 2.375 6.675V13.325C2.375 14.6551 2.375 15.3202 2.63386 15.8282C2.86156 16.2751 3.22489 16.6384 3.67177 16.8661C4.17981 17.125 4.84488 17.125 6.175 17.125Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInsightsIcon;
